import { basicEnum } from "./base";

export const ONTBlockFieldEnum = basicEnum([
    {
        label: "OUI",
        value: "oui",
    },
    {
        label: "Manufacturer",
        value: "manufacturer",
    },
    {
        label: "Product Class",
        value: "productClass",
    },
    {
        label: "Serial Number",
        value: "serialNumber",
    },
]);

export namespace ONTBlockFieldEnum {
    export type Labels = (typeof ONTBlockFieldEnum)["labels"][number];
    export type Values = (typeof ONTBlockFieldEnum)["values"][number];
}
